module.exports = __webpack_public_path__ + "static/media/sre-boat.f8295887.svg";